import * as API from '@/services';
import { prepareContentWithBase64Images } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import {
	formatCommonNoticeReceiveDetail,
	formatCommonNoticeReceiveList,
} from './common-notice-receive.helper';
import { CommonNoticeReceiveActions } from './common-notice-receive.redux';
import {
	IPayloadDeleteCommonNoticeReceiveRequest,
	IPayloadGetCommonNoticeReceiveDetailRequest,
	IPayloadGetCommonNoticeReceiveListRequest,
} from './common-notice-receive.type';

export function* getCommonNoticeReceiveList(
	action: PayloadAction<IPayloadGetCommonNoticeReceiveListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetCommonNoticeListResponse> =
			yield API.getCommonNoticeReceiveList({ searchTypes, ...rest });
		const content = formatCommonNoticeReceiveList(res?.data?.content);

		yield put(
			CommonNoticeReceiveActions.getCommonNoticeReceiveListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonNoticeReceiveActions.getCommonNoticeReceiveListFailure());
	}
}

export function* deleteCommonNoticeReceives(
	action: PayloadAction<IPayloadDeleteCommonNoticeReceiveRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteCommonNoticeReceive(ids);

		yield put(CommonNoticeReceiveActions.deleteCommonNoticeReceiveSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonNoticeReceiveActions.deleteCommonNoticeReceiveFailure());
	}
}

export function* getCommonNoticeReceiveDetail(
	action: PayloadAction<IPayloadGetCommonNoticeReceiveDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.ICommonNotice> =
			yield API.getCommonNoticeReceiveDetail(id);

		const detail = formatCommonNoticeReceiveDetail(res.data);

		const content: string = yield prepareContentWithBase64Images(
			detail.content
		);

		yield put(
			CommonNoticeReceiveActions.getCommonNoticeReceiveDetailSuccess({
				detail: {
					...detail,
					content,
				},
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonNoticeReceiveActions.getCommonNoticeReceiveDetailFailure());
	}
}
